<template>
    <component v-if="dashBoardType" v-bind:is="dashBoardType"></component>
</template>

<script>


import DefaultDashboard from "./dashboards/DefaultDashboard";
import ShtDashboard from "./dashboards/ShtDashboard";
import CrpDashboard from "./dashboards/CrpDashboard";
import Es3Dashboard from "./dashboards/Es3Dashboard";
import EsDashboard from "./dashboards/EsDashboard";
import Notifications from "./Notifications";
import AADashboard from "./dashboards/AADashboard";

    export default {
        name: 'DashboardGateway',
        components: { DefaultDashboard,ShtDashboard,CrpDashboard,Es3Dashboard,EsDashboard,Notifications,AADashboard},
        data () {
            return {
                dashBoardType:null

            }
        },
        methods:{

        },
        mounted() {
            if(process.env.VUE_APP_DASHBOARD_TYPE&&process.env.VUE_APP_DASHBOARD_TYPE!==""){
                this.dashBoardType=process.env.VUE_APP_DASHBOARD_TYPE
            } else {
                let facility = this.$store.state.pointsListStore.pointsList.facility_name
                switch (facility) {
                    case 'SHT':
                        this.dashBoardType = "sht-dashboard"
                        break;
                    case 'CRP':
                        this.dashBoardType = "crp-dashboard"
                        break;
                    case 'ES3':
                        this.dashBoardType = "es3-dashboard"
                        break;
                    case 'ES':
                        this.dashBoardType = "es-dashboard"
                        break;
                    case 'AZBIL':
                        this.dashBoardType = "notifications"
                        break;
                    default:
                        this.dashBoardType = "default-dashboard"
                }
            }
        }


    }
</script>
